import classes from './Banner.module.css'
import { FC, ComponentType } from 'react'
import { BannerContent } from '../BannerContentDulap/BannerContentDulap'
import Image from '~/components/common/Image'

interface ResponsiveSources {
  webpSrcSet?: string
  jpegSrcSet?: string
  sizes?: string
}

interface BannerProps {
  href?: string
  mobileHref?: string
  desktopSources?: ResponsiveSources
  mobileSources?: ResponsiveSources
  blurDataURL?: string
  content?: ComponentType
  hideRadius?: boolean
}

const DEFAULT_BLUR =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNjAwJyBoZWlnaHQ9JzQwMCcgdmlld0JveD0nMCAwIDYwMCA0MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHJlY3Qgd2lkdGg9JzYwMCcgaGVpZ2h0PSc0MDAnIGZpbGw9JyNFMEUwRTAnLz48L3N2Zz4="

export const Banner: FC<BannerProps> = ({
  href,
  mobileHref,
  desktopSources,
  mobileSources,
  blurDataURL = DEFAULT_BLUR,
  content: Content = BannerContent,
  hideRadius = false,
}) => {
  const desktopSrc = href || '/banner-2.jpg'
  const mobileSrc = mobileHref || '/banner-2.jpg'
  const hasDesktopSources =
    !!desktopSources?.webpSrcSet || !!desktopSources?.jpegSrcSet
  const hasMobileSources =
    !!mobileSources?.webpSrcSet || !!mobileSources?.jpegSrcSet

  return (
    <section
      className={`${classes.hero} ${hideRadius ? classes.hideRadius : ''}`}
    >
      {hasDesktopSources ? (
        <picture className={classes.desktop} style={{ width: '100%' }}>
          {desktopSources!.webpSrcSet && (
            <source
              type="image/webp"
              srcSet={desktopSources!.webpSrcSet}
              sizes={desktopSources!.sizes}
            />
          )}
          {desktopSources!.jpegSrcSet && (
            <source
              type="image/jpeg"
              srcSet={desktopSources!.jpegSrcSet}
              sizes={desktopSources!.sizes}
            />
          )}
          <img
            src={desktopSrc}
            width={2056}
            height={1000}
            className={classes.heroImage}
            alt="Hero showcasing furniture"
            decoding="async"
            fetchPriority="high"
          />
        </picture>
      ) : (
        <Image
          width={2056}
          height={1000}
          className={`${classes.heroImage} ${classes.desktop}`}
          src={desktopSrc}
          alt="Hero showcasing furniture"
          priority
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
      )}

      {hasMobileSources ? (
        <picture className={classes.mobile} style={{ width: '100%' }}>
          {mobileSources!.webpSrcSet && (
            <source
              type="image/webp"
              srcSet={mobileSources!.webpSrcSet}
              sizes={mobileSources!.sizes}
            />
          )}
          {mobileSources!.jpegSrcSet && (
            <source
              type="image/jpeg"
              srcSet={mobileSources!.jpegSrcSet}
              sizes={mobileSources!.sizes}
            />
          )}
          <img
            src={mobileSrc}
            width={400}
            height={600}
            className={classes.heroImage}
            alt="Hero showcasing furniture – mobile"
            decoding="async"
            fetchPriority="high"
          />
        </picture>
      ) : (
        <Image
          height={600}
          width={400}
          src={mobileSrc}
          priority
          decoding="async"
          className={`${classes.heroImage} ${classes.mobile}`}
          alt="Hero showcasing furniture – mobile"
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
      )}

      <div className={classes.overlay}></div>
      <Content />
    </section>
  )
}